module.exports = __webpack_public_path__ + "img/avatar5.7bd4f2ad.png";